import { render, staticRenderFns } from "./SalesNote.vue?vue&type=template&id=c3e272bc&scoped=true&"
import script from "./SalesNote.vue?vue&type=script&lang=js&"
export * from "./SalesNote.vue?vue&type=script&lang=js&"
import style0 from "./SalesNote.vue?vue&type=style&index=0&id=c3e272bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e272bc",
  null
  
)

export default component.exports